var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxPaymentCouponOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.4154C2.5 11.8828 2.8782 12.2616 3.34474 12.2616H12.6553C13.1218 12.2616 13.5 11.8828 13.5 11.4154V9.69433C12.7687 9.49578 12.2307 8.82623 12.2307 8.03082C12.2307 7.23541 12.7687 6.56585 13.5 6.3673V4.6462C13.5 4.17889 13.1218 3.80005 12.6553 3.80005H3.34474C2.87821 3.80005 2.5 4.17888 2.5 4.6462V6.36358C3.23844 6.55738 3.78324 7.23036 3.78324 8.03082C3.78324 8.83127 3.23844 9.50426 2.5 9.69805V11.4154Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9043 10.1465L10.1351 5.91577",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32737 6.76193C6.56103 6.76193 6.75045 6.57251 6.75045 6.33885C6.75045 6.10519 6.56103 5.91577 6.32737 5.91577C6.09372 5.91577 5.9043 6.10519 5.9043 6.33885C5.9043 6.57251 6.09372 6.76193 6.32737 6.76193Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71019 10.1464C9.94384 10.1464 10.1333 9.95703 10.1333 9.72337C10.1333 9.48971 9.94384 9.30029 9.71019 9.30029C9.47653 9.30029 9.28711 9.48971 9.28711 9.72337C9.28711 9.95703 9.47653 10.1464 9.71019 10.1464Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxPaymentCouponOutline);
export default __webpack_public_path__ + "static/media/icon_16px_payment-coupon_outline.6daeed6a329739deea34e52b123a0be4.svg";
export { ForwardRef as ReactComponent };